export const getCssVariable = (s: string) => window.getComputedStyle(document.documentElement).getPropertyValue(s);
